import React, {Component} from 'react'
import CustomAccordion from "./CustomAccordion";
import getURLParam from "../Constants/getURLParam";

class SampleQuestionsAccordion extends Component {
    constructor(props) {
        super(props);
        this.state = {
            questions: [],
            loading: false,
            error: null
        };
    }

    componentDidMount() {
        if (this.props.questions && Array.isArray(this.props.questions)) {
            this.setState({ 
                questions: this.props.questions,
                loading: false 
            });
        } else {
            this.fetchSampleQuestions();
        }
    }

    fetchSampleQuestions = async () => {
        try {
            this.setState({ loading: true, error: null });
            
            // Get file hash from URL or use provided fileHash prop
            const fileHash = this.props.fileHash || getURLParam(window.location.href);
            
            // Determine API root based on browser domain
            const browserDomain = window.location.origin;
            let apiRoot;
            
            if (browserDomain.includes("localhost")) {
                apiRoot = "http://127.0.0.1:8080/";
            } else {
                apiRoot = "https://api.apispreadsheets.com/";
            }
            
            const response = await fetch(`${apiRoot}generate-questions/${fileHash}/`);
            
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            
            const data = await response.json();
            this.setState({ 
                questions: data.sample_questions || [],
                loading: false 
            });
        } catch (error) {
            console.error('Error fetching sample questions:', error);
            this.setState({ 
                error: 'Failed to load sample questions',
                loading: false 
            });
        }
    };

    render() {
        const { questions, loading, error } = this.state;
        
        return (
            <CustomAccordion
                open={this.props.open}
                body={
                    <div>
                        {loading && (
                            <div style={{ textAlign: "center", padding: "20px" }}>
                                <p>Loading sample questions...</p>
                            </div>
                        )}
                        
                        {error && (
                            <div style={{ textAlign: "center", padding: "20px", color: "#d32f2f" }}>
                                <p>{error}</p>
                                <button 
                                    onClick={this.fetchSampleQuestions}
                                    style={{
                                        padding: "8px 16px",
                                        backgroundColor: "#1976d2",
                                        color: "white",
                                        border: "none",
                                        borderRadius: "4px",
                                        cursor: "pointer"
                                    }}
                                >
                                    Retry
                                </button>
                            </div>
                        )}
                        
                        {!loading && !error && questions.length > 0 && (
                            <div style={{ padding: "0px 12px", fontSize: "14px", fontWeight: "500" }}>
                                <p style={{ marginBottom: "16px", color: "rgb(94, 100, 94)", fontSize: "16px" }}>
                                    Here are {questions.length} sample questions you can ask about your data:
                                </p>
                                <ol style={{ paddingLeft: "20px" }}>
                                    {questions.map((question, index) => (
                                        <li key={index} style={{ 
                                            marginBottom: "12px", 
                                            lineHeight: "1.5",
                                            color: "#333"
                                        }}>
                                            {question}
                                        </li>
                                    ))}
                                </ol>
                            </div>
                        )}
                        
                        {!loading && !error && questions.length === 0 && (
                            <div style={{ textAlign: "center", padding: "20px", color: "#666" }}>
                                <p>No sample questions available for this file.</p>
                            </div>
                        )}
                    </div>
                }
                header={this.props.header || "Sample Questions"}
                accordionStyle={{
                    borderRadius: '4px',
                    border: "1px solid #F0F0F0",
                    backgroundColor: 'white',
                    ...this.props.accordionStyle
                }}
                headerDivStyle={{
                    borderRadius: '4px',
                    backgroundColor: 'white',
                    fontSize: '16px',
                    fontWeight: '700',
                    fontFamily: "Lato",
                    padding: "16px",
                    ...this.props.headerDivStyle
                }}
            />
        );
    }
}

export default SampleQuestionsAccordion;